module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksby",
    attrs: {
      "id": "booksby"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitleB-1"
  }, [_vm._v("Books by Jerome A. Greene")])]), _vm._v(" "), _c('p', {
    staticClass: "altPara1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Evidence and the Custer Enigma: A Reconstruction of Indian-Military History")]), _vm._v(" (Kansas City, 1973)")]), _vm._v(" "), _c('p', {
    staticClass: "altPara2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Slim Buttes, 1876: An Episode of the Great Sioux War")]), _vm._v(" (Norman, 1982)")]), _vm._v(" "), _c('p', {
    staticClass: "altPara2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Yellowstone Command: Colonel Nelson A. Miles and the Great Sioux War, 1876-1877")]), _vm._v("(Lincoln, 1991; Norman, 2006)")]), _vm._v(" "), _c('p', {
    staticClass: "altPara2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Battles and Skirmishes of the Great Sioux War, 1876-1877: The Military View")]), _vm._v(" (Norman, 1993)")]), _vm._v(" "), _c('p', {
    staticClass: "altPara2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lakota and Cheyenne: Indian Views of the Great Sioux War, 1876-1877")]), _vm._v(" (Norman, 1994)")]), _vm._v(" "), _c('p', {
    staticClass: "altPara2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Frontier Soldier: An Enlisted Man’s Journal of the Sioux and Nez Perce Campaigns, 1877")]), _vm._v(" (Helena, 1998)")]), _vm._v(" "), _c('p', {
    staticClass: "altPara2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Nez Perce Summer, 1877: The U. S. Army and the Nee-Me-Poo Crisis")]), _vm._v(" (Helena, 2000)")]), _vm._v(" "), _c('p', {
    staticClass: "altPara2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Morning Star Dawn: The Powder River Expedition and the Northern Cheyennes, 1876")]), _vm._v("(Norman, 2003)")]), _vm._v(" "), _c('p', {
    staticClass: "altPara2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Washita: The U. S. Army and the Southern Cheyennes, 1867-1869")]), _vm._v(" (Norman, 2004)")]), _vm._v(" "), _c('p', {
    staticClass: "altPara2"
  }, [_vm._v("(Co-author with Douglas D. Scott) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Finding Sand Creek: History, Archeology, and the 1864 Massacre Site")]), _vm._v(" (Norman, 2004)")]), _vm._v(" "), _c('p', {
    staticClass: "altPara2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Guns of Independence: The Siege of Yorktown")]), _vm._v(", 1781 (New York and Staplehurst, UK, 2005)")]), _vm._v(" "), _c('p', {
    staticClass: "altPara2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Fort Randall on the Missouri, 1856-1892")]), _vm._v("(Pierre, 2005)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f42d825","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndianWarVeterans_booksby.vue
// module id = 66
// module chunks = 0